// extracted by mini-css-extract-plugin
module.exports = {"vapsCtaButtonContainer":"cta-button_vapsCtaButtonContainer__WcXmn"};